import { render, staticRenderFns } from "./FormGallery.vue?vue&type=template&id=a0b7161e&"
import script from "./FormGallery.vue?vue&type=script&lang=js&"
export * from "./FormGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports